import { defaultIconColor } from './constants';
import { SVGComponentPropsType } from './types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height={`${size}`}
    width={`${size}`}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    fill="none"
    {...props}
  >
    <path
      d="m6.3432 13.4142-.7071.7071c-1.1716 1.1716-1.1716 3.0711 0 4.2426l.707.7071c1.1717 1.1716 3.0711 1.1716 4.2427 0l3.5356-3.5355c1.1715-1.1716 1.1715-3.0711 0-4.2426l-.7072-.7071"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="m17.6568 10.5858.7071-.707c1.1716-1.1717 1.1716-3.0712 0-4.2427l-.7071-.7071c-1.1716-1.1716-3.071-1.1716-4.2426 0L9.8786 8.4645c-1.1715 1.1716-1.1715 3.0711 0 4.2426l.7072.7071"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
